// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"250":"e81dfc13","641":"e81dfc13"}[chunkId] + ".css";
};